import gtmPusher from '../../utils/gtmPusher';

const stepAnalytics = reviewArr => {
  // GOOGLE ANALYTICS
  const products = [];
  reviewArr.forEach(type => {
    type.products.forEach(product => {
      product.sizes.forEach(size => {
        products.push({
          ...product,
          product_id: product.id,
          product: product.name,
          quantity: size.quantity,
          unit_net: (product.unit_net_price / 100).toFixed(2),
          size: size.name,
          variant: '',
          sublines: size.customizations
            .reduce((acc, cur) => [...acc, ...cur], [])
            .map(customization => ({
              ...customization,
              unit_price: (customization.price / 100).toFixed(2),
              variant: customization.type,
              product: `${customization.type}: ${customization.properties.render_value}`,
              line_total: customization.price
            }))
        });
      });
    });
  });

  const ecommerceObj = {
    event: 'addToCart',
    eventCategory: 'ecommerce',
    eventAction: 'add to cart',
    eventLabel: 'team product',
    eventValue: 0,
    eventNonInteraction: false,
    virtualPath: '/summary',
    userId: '',
    list: 'product configuration page: teamsport',
    currencyCode: window.config.default_currency
  };
  gtmPusher(ecommerceObj, products);
  // -- END GOOGLE ANALYTICS --
};

export default stepAnalytics;
